export default "__VITE_ASSET__8824770d__"